import React, { useEffect, useState } from 'react';

// Compteur animé (count-up) vers la valeur cible
export const useCountUp = (target, ms = 700) => {
  const [v, setV] = useState(target);
  useEffect(() => {
    const from = v, to = Number(target) || 0, t0 = performance.now();
    if (from === to) return undefined;
    let raf;
    const tick = (t) => { const k = Math.min(1, (t - t0) / ms); const e = 1 - Math.pow(1 - k, 3); setV(Math.round(from + (to - from) * e)); if (k < 1) raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target]); // eslint-disable-line react-hooks/exhaustive-deps
  return v;
};

/** Anneau du solde : part restante du mois (solde / (solde + consommé ce mois)). */
export const CreditsRing = ({ balance, used, preview = 0, free }) => {
  const shown = useCountUp(balance + preview);
  const total = Math.max(1, balance + preview + used);
  const frac = free ? 1 : Math.max(0, Math.min(1, (balance + preview) / total));
  const R = 54, C = 2 * Math.PI * R;
  return <div className="credits-ring" data-testid="credits-ring" data-balance={balance}>
    <svg viewBox="0 0 128 128" aria-hidden>
      <circle cx="64" cy="64" r={R} className="credits-ring-bg" />
      <circle cx="64" cy="64" r={R} className="credits-ring-fg" strokeDasharray={C} strokeDashoffset={C * (1 - frac)} />
      {preview > 0 && <circle cx="64" cy="64" r={R} className="credits-ring-preview" strokeDasharray={C} strokeDashoffset={C * (1 - Math.min(1, preview / total))} />}
    </svg>
    <div className="credits-ring-txt">
      <b data-testid="credits-ring-value">{free ? '∞' : shown.toLocaleString('fr-FR')}</b>
      <small>{preview > 0 ? `+${preview.toLocaleString('fr-FR')} après achat` : used > 0 ? `${used.toLocaleString('fr-FR')} utilisés ce mois` : 'crédits disponibles'}</small>
    </div>
  </div>;
};
